// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DiligenciaDetalleVista — Layout B (Datos + Panel).
   Shell: \`.page\` (atoms.css) + PageHead (kicker → title + actions → sub →
   meta band) → \`.dnav\` band with the 5-stage stepper → \`.dbody .cb-cols\`
   (322px sticky aside | merged estado panel). The shared detail vocabulary
   (.dnav/.dbody/.cb-cols/.cb-aside/.cb-fichahead/.dd-info/.dd-iconbtn) lives
   in styles/detail.css; this file holds only what is diligencia-specific:
   the stepper, the Concepto B panel (canon block below) and the not-found. */

/* .dd-page's min-height lives with .cd-page's in styles/detail.css. */

/* ── 5-stage stepper (sits inside the .dnav band from styles/detail.css) ── */
.stepper2 {
  display: flex;
  align-items: center;
  gap: 0;
  margin-bottom: 28px;
  flex-wrap: wrap;
}
.stp {
  display: flex;
  align-items: center;
  gap: 9px;
  padding-right: 14px;
  margin-right: 14px;
  border-right: 1px solid var(--rule-soft);
  color: var(--ink-3);
}
.stp:last-child {
  border-right: 0;
  margin-right: 0;
}
.stp__dot {
  width: 22px;
  height: 22px;
  border-radius: 999px;
  display: grid;
  place-items: center;
  border: 1px solid var(--rule);
  font-family: var(--mono);
  font-size: var(--fs-sm);
  flex: none;
}
.stp__lbl {
  font-size: var(--fs-2xs);
}
.stp--done {
  color: var(--ink-2);
}
.stp--done .stp__dot {
  background: var(--accent);
  border-color: var(--accent);
  color: var(--accent-ink);
}
.stp--now {
  color: var(--ink);
  font-weight: 500;
}
.stp--now .stp__dot {
  border-color: var(--accent);
  color: var(--accent);
  border-width: 2px;
}

/* Spacing wrapper for the "Estado" kicker above the panel. */
.dil-side__kicker {
  margin-bottom: 12px;
}

/* Accent text-link (Editar in the aside head): .card__link, styled by the
   byte-identical rule in CausaDetalleVista.css (all page CSS is global).
   NOTE: Pagos.css also declares .card__link later in the cascade, so its
   font-size/display declarations win — a pre-existing collision. */

/* Offer picker radio (shared with the prototype's pick mode). */
.offer__radio {
  width: 16px;
  height: 16px;
  border-radius: 999px;
  border: 1px solid var(--rule);
  flex: none;
}
.offer__radio--on {
  border-color: var(--accent);
  border-width: 5px;
}

/* =========================================================
   CONCEPTO B — merged estado + cotizaciones panel.
   Canon block from the prototype (propuestas.css); keep values verbatim.
   ========================================================= */
.cb-panel {
  border: 1px solid var(--rule);
  background: var(--surface);
}
.cb-panel__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 15px 18px;
  border-bottom: 1px solid var(--rule);
}
.cb-panel__hl {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.cb-panel__title {
  font-size: var(--fs-md);
  font-weight: 500;
  color: var(--ink);
}
.cb-panel__sub {
  font-size: var(--fs-2xs);
  color: var(--ink-3);
}
.cb-panel__body {
  padding: 16px 18px;
}
.cb-panel__foot {
  border-top: 1px solid var(--rule);
  background: var(--bg-alt);
  padding: 14px 18px;
  position: sticky;
  bottom: 0;
}
.cb-pay {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}
.cb-pay__l {
  display: flex;
  flex-direction: column;
  gap: 2px;
}
.cb-pay__lbl {
  font-size: var(--fs-meta);
  color: var(--ink-3);
}
.cb-pay__amt {
  font-family: var(--mono);
  font-size: var(--fs-prose);
  color: var(--ink);
  font-variant-numeric: tabular-nums;
}
.cb-pay__break {
  font-size: var(--fs-xs);
  color: var(--ink-3);
}
.cb-panel__note {
  font-size: var(--fs-2xs);
  color: var(--ink-3);
  line-height: 1.45;
  margin: 0 0 4px;
}
.cb-panel__foldbtn {
  background: none;
  border: 0;
  padding: 10px 0 0;
  cursor: pointer;
  color: var(--accent);
  font-size: var(--fs-meta);
  font-family: var(--sans);
}
.cb-panel__foldbtn:hover {
  text-decoration: underline;
}
.cb-statusline {
  margin-top: 14px;
  padding-top: 14px;
  border-top: 1px solid var(--rule-soft);
}

/* offers dentro del panel: sin card doble, filas separadas por hairline */
.cb-offer {
  display: flex;
  align-items: center;
  gap: 13px;
  padding: 13px 2px;
  border-bottom: 1px solid var(--rule-soft);
  width: 100%;
  text-align: left;
  font: inherit;
  color: inherit;
  background: none;
  border-left: 0;
  border-right: 0;
  border-top: 0;
}
.cb-offer:last-child {
  border-bottom: 0;
}
.cb-offer[role='button'] {
  cursor: pointer;
}
.cb-offer[role='button']:hover {
  background: var(--bg-alt);
}
.cb-offer--on {
  background: var(--accent-soft);
}
.cb-offer__main {
  flex: 1;
  min-width: 0;
}
.cb-offer__top {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-wrap: wrap;
}
.cb-offer__name {
  font-size: var(--fs-note);
  color: var(--ink);
}
.cb-offer__sub {
  margin-top: 3px;
  font-size: var(--fs-meta);
  color: var(--ink-3);
}
.cb-offer__amt {
  font-family: var(--mono);
  font-size: var(--fs-note);
  color: var(--ink);
  white-space: nowrap;
}

/* Page adaptations of the canon block (values lifted from the prototype's
   inline styles / the previous page css — no new values). */
.cb-offer--on {
  padding: 13px 12px;
}
.cb-offer--mute {
  opacity: 0.6;
}
.cb-offer .st {
  font-size: var(--fs-meta);
}
.cb-panel__note--after {
  margin-top: 12px;
}

/* NotFound UI uses the shared .detail-notfound (styles/detail.css). */

/* lectura de pago caída, en el pie del panel */
.cb-pay__amt--err {
  color: var(--danger);
  font-size: var(--fs-note);
}
.cb-pay__retry {
  border: 0;
  background: none;
  padding: 0;
  font: inherit;
  color: var(--text);
  text-decoration: underline;
  cursor: pointer;
}
.cb-pay__retry:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

/* The receptor's price per recipient under the offer (REC-1983). */
.cb-offer__breakdown {
  margin: 4px 0 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 2px;
  font-size: var(--fs-meta);
  color: var(--ink-3);
}
`, "",{"version":3,"sources":["webpack://./src/pages/diligencias/DiligenciaDetalleVista.css"],"names":[],"mappings":"AAAA;;;;;;6EAM6E;;AAE7E,sEAAsE;;AAEtE,8EAA8E;AAC9E;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;EACxC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,wBAAwB;EACxB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,6DAA6D;AAC7D;EACE,mBAAmB;AACrB;;AAEA;;;mEAGmE;;AAEnE,gEAAgE;AAChE;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,6BAA6B;EAC7B,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,iBAAiB;AACnB;;AAEA;;;8DAG8D;AAC9D;EACE,6BAA6B;EAC7B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,oCAAoC;AACtC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,iBAAiB;EACjB,kCAAkC;AACpC;AACA;EACE,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,yBAAyB;EACzB,wBAAwB;AAC1B;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,OAAO;EACP,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;4DAC4D;AAC5D;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;;AAEA,sEAAsE;;AAEtE,+CAA+C;AAC/C;EACE,oBAAoB;EACpB,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,mEAAmE;AACnE;EACE,eAAe;EACf,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;AACrB","sourcesContent":["/* DiligenciaDetalleVista — Layout B (Datos + Panel).\n   Shell: `.page` (atoms.css) + PageHead (kicker → title + actions → sub →\n   meta band) → `.dnav` band with the 5-stage stepper → `.dbody .cb-cols`\n   (322px sticky aside | merged estado panel). The shared detail vocabulary\n   (.dnav/.dbody/.cb-cols/.cb-aside/.cb-fichahead/.dd-info/.dd-iconbtn) lives\n   in styles/detail.css; this file holds only what is diligencia-specific:\n   the stepper, the Concepto B panel (canon block below) and the not-found. */\n\n/* .dd-page's min-height lives with .cd-page's in styles/detail.css. */\n\n/* ── 5-stage stepper (sits inside the .dnav band from styles/detail.css) ── */\n.stepper2 {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  margin-bottom: 28px;\n  flex-wrap: wrap;\n}\n.stp {\n  display: flex;\n  align-items: center;\n  gap: 9px;\n  padding-right: 14px;\n  margin-right: 14px;\n  border-right: 1px solid var(--rule-soft);\n  color: var(--ink-3);\n}\n.stp:last-child {\n  border-right: 0;\n  margin-right: 0;\n}\n.stp__dot {\n  width: 22px;\n  height: 22px;\n  border-radius: 999px;\n  display: grid;\n  place-items: center;\n  border: 1px solid var(--rule);\n  font-family: var(--mono);\n  font-size: var(--fs-sm);\n  flex: none;\n}\n.stp__lbl {\n  font-size: var(--fs-2xs);\n}\n.stp--done {\n  color: var(--ink-2);\n}\n.stp--done .stp__dot {\n  background: var(--accent);\n  border-color: var(--accent);\n  color: var(--accent-ink);\n}\n.stp--now {\n  color: var(--ink);\n  font-weight: 500;\n}\n.stp--now .stp__dot {\n  border-color: var(--accent);\n  color: var(--accent);\n  border-width: 2px;\n}\n\n/* Spacing wrapper for the \"Estado\" kicker above the panel. */\n.dil-side__kicker {\n  margin-bottom: 12px;\n}\n\n/* Accent text-link (Editar in the aside head): .card__link, styled by the\n   byte-identical rule in CausaDetalleVista.css (all page CSS is global).\n   NOTE: Pagos.css also declares .card__link later in the cascade, so its\n   font-size/display declarations win — a pre-existing collision. */\n\n/* Offer picker radio (shared with the prototype's pick mode). */\n.offer__radio {\n  width: 16px;\n  height: 16px;\n  border-radius: 999px;\n  border: 1px solid var(--rule);\n  flex: none;\n}\n.offer__radio--on {\n  border-color: var(--accent);\n  border-width: 5px;\n}\n\n/* =========================================================\n   CONCEPTO B — merged estado + cotizaciones panel.\n   Canon block from the prototype (propuestas.css); keep values verbatim.\n   ========================================================= */\n.cb-panel {\n  border: 1px solid var(--rule);\n  background: var(--surface);\n}\n.cb-panel__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 15px 18px;\n  border-bottom: 1px solid var(--rule);\n}\n.cb-panel__hl {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n}\n.cb-panel__title {\n  font-size: var(--fs-md);\n  font-weight: 500;\n  color: var(--ink);\n}\n.cb-panel__sub {\n  font-size: var(--fs-2xs);\n  color: var(--ink-3);\n}\n.cb-panel__body {\n  padding: 16px 18px;\n}\n.cb-panel__foot {\n  border-top: 1px solid var(--rule);\n  background: var(--bg-alt);\n  padding: 14px 18px;\n  position: sticky;\n  bottom: 0;\n}\n.cb-pay {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n.cb-pay__l {\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n.cb-pay__lbl {\n  font-size: var(--fs-meta);\n  color: var(--ink-3);\n}\n.cb-pay__amt {\n  font-family: var(--mono);\n  font-size: var(--fs-prose);\n  color: var(--ink);\n  font-variant-numeric: tabular-nums;\n}\n.cb-pay__break {\n  font-size: var(--fs-xs);\n  color: var(--ink-3);\n}\n.cb-panel__note {\n  font-size: var(--fs-2xs);\n  color: var(--ink-3);\n  line-height: 1.45;\n  margin: 0 0 4px;\n}\n.cb-panel__foldbtn {\n  background: none;\n  border: 0;\n  padding: 10px 0 0;\n  cursor: pointer;\n  color: var(--accent);\n  font-size: var(--fs-meta);\n  font-family: var(--sans);\n}\n.cb-panel__foldbtn:hover {\n  text-decoration: underline;\n}\n.cb-statusline {\n  margin-top: 14px;\n  padding-top: 14px;\n  border-top: 1px solid var(--rule-soft);\n}\n\n/* offers dentro del panel: sin card doble, filas separadas por hairline */\n.cb-offer {\n  display: flex;\n  align-items: center;\n  gap: 13px;\n  padding: 13px 2px;\n  border-bottom: 1px solid var(--rule-soft);\n  width: 100%;\n  text-align: left;\n  font: inherit;\n  color: inherit;\n  background: none;\n  border-left: 0;\n  border-right: 0;\n  border-top: 0;\n}\n.cb-offer:last-child {\n  border-bottom: 0;\n}\n.cb-offer[role='button'] {\n  cursor: pointer;\n}\n.cb-offer[role='button']:hover {\n  background: var(--bg-alt);\n}\n.cb-offer--on {\n  background: var(--accent-soft);\n}\n.cb-offer__main {\n  flex: 1;\n  min-width: 0;\n}\n.cb-offer__top {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex-wrap: wrap;\n}\n.cb-offer__name {\n  font-size: var(--fs-note);\n  color: var(--ink);\n}\n.cb-offer__sub {\n  margin-top: 3px;\n  font-size: var(--fs-meta);\n  color: var(--ink-3);\n}\n.cb-offer__amt {\n  font-family: var(--mono);\n  font-size: var(--fs-note);\n  color: var(--ink);\n  white-space: nowrap;\n}\n\n/* Page adaptations of the canon block (values lifted from the prototype's\n   inline styles / the previous page css — no new values). */\n.cb-offer--on {\n  padding: 13px 12px;\n}\n.cb-offer--mute {\n  opacity: 0.6;\n}\n.cb-offer .st {\n  font-size: var(--fs-meta);\n}\n.cb-panel__note--after {\n  margin-top: 12px;\n}\n\n/* NotFound UI uses the shared .detail-notfound (styles/detail.css). */\n\n/* lectura de pago caída, en el pie del panel */\n.cb-pay__amt--err {\n  color: var(--danger);\n  font-size: var(--fs-note);\n}\n.cb-pay__retry {\n  border: 0;\n  background: none;\n  padding: 0;\n  font: inherit;\n  color: var(--text);\n  text-decoration: underline;\n  cursor: pointer;\n}\n.cb-pay__retry:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n/* The receptor's price per recipient under the offer (REC-1983). */\n.cb-offer__breakdown {\n  margin: 4px 0 0;\n  padding: 0;\n  list-style: none;\n  display: grid;\n  gap: 2px;\n  font-size: var(--fs-meta);\n  color: var(--ink-3);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
